import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ items, className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const defaultItems = React.useMemo(() => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    
    const routeLabels = {
      dashboard: 'Dashboard',
      'content-list': 'Content List',
      'content-editor': 'Content Editor',
      'media-library': 'Media Library',
      'content-analytics': 'Analytics',
      'user-management': 'Users',
    };

    return pathSegments?.map((segment, index) => {
      const path = `/${pathSegments?.slice(0, index + 1)?.join('/')}`;
      return {
        label: routeLabels?.[segment] || segment?.charAt(0)?.toUpperCase() + segment?.slice(1),
        path: path,
      };
    });
  }, [location?.pathname]);

  const breadcrumbItems = items || defaultItems;

  if (breadcrumbItems?.length === 0) {
    return null;
  }

  const handleClick = (path, index) => {
    if (index < breadcrumbItems?.length - 1 && path) {
      navigate(path);
    }
  };

  return (
    <nav className={`breadcrumbs ${className}`.trim()} aria-label="Breadcrumb">
      <div className="breadcrumb-item">
        <span
          onClick={() => navigate('/dashboard')}
          className="breadcrumb-link"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e?.key === 'Enter' || e?.key === ' ') {
              e?.preventDefault();
              navigate('/dashboard');
            }
          }}
        >
          <Icon name="Home" size={16} />
        </span>
      </div>
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path}>
          <span className="breadcrumb-separator">
            <Icon name="ChevronRight" size={16} />
          </span>
          <div className="breadcrumb-item">
            {index < breadcrumbItems?.length - 1 ? (
              <span
                onClick={() => item?.path && handleClick(item?.path, index)}
                className="breadcrumb-link"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e?.key === 'Enter' || e?.key === ' ') {
                    e?.preventDefault();
                    item?.path && handleClick(item?.path, index);
                  }
                }}
              >
                {item?.label}
              </span>
            ) : (
              <span className="text-foreground font-medium">{item?.label}</span>
            )}
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;